export const searchHandler = ()=>{
	document.addEventListener('DOMContentLoaded', () => {
		const form = document.getElementById('search-form');
		if (!form) return;

		form.addEventListener('submit', (e) => {
			e.preventDefault();
			const query = form.querySelector('input[name="site_search"]').value.trim();
			if (!query) return;
			window.location.href = `${window.location.origin}/search?s=${encodeURIComponent(query)}`;
		});
	});
}
